import { keyframes } from "@mui/material/styles";

const pulse = keyframes`
    0% {
      transform: scale(0.75);
      opacity: 0.6;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.3;
    }
    100% {
      transform: scale(0.75);
      opacity: 0.6;
    }
  `;

export const actionButtonStyle = {
  actionTitle: {
    fontSize: "10px",
    textAlign: "center",
    marginTop: "-5px",
    wordBreak: "break-all",
  },
  actionButtonDivider: {
    height: "1px",
    background: "#aaa",
    width: "70%",
    marginTop: "4px",
  },
  pulse: {
    position: "relative",
    overflow: "visible",
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      backgroundColor: "primary.main",
      borderRadius: "inherit",
      animation: `${pulse} 2s cubic-bezier(0.24, 0, 0.38, 1) infinite`,
      zIndex: -1,
      transition: "opacity 1s, transform 1s",
    },
  },
};
